export const locale = {
  'CANCELCONFIRM' : {
    'TITLE' : 'Отменить заказ',
    'MESSAGE' : 'Вы уверены, что хотите отменить эти заказы?',
    'CONFIRM' : 'Да, отменить',
    'DECLINE' : 'Закрыть',
    'ORDERNUMBER' : 'Заказ №',
  },
};
